export default __webpack_public_path__ + "static/media/youtube.4ab4a70a.png";